import ToDoItem from './todo.item';
import {withStyles} from '@material-ui/core/styles';
import * as React from 'react';
import * as TodoActions from '@services/todos/todo.action';
import {connect} from 'react-redux';
import {ICompleteTodo, IHideTodo, ITodo, TODO_TYPE} from '@app-types/websocket/todo.types';
import {IFamilyMember} from '@app-types/websocket/family.types';
import EditTodoDialog from './EditTodoDialog';
import {FamilyMemberType} from '@services/family/family.constants';
import TranslateNew from '@translate/TranslateNew';
import {TodoListStyle as styles} from './TodoList.style';
import CalendarTodos from './CalendarTodos';


const tn: TranslateNew = TranslateNew.getInstance();



interface IProps {
  classes: any;
  myAccountId: number;
  todos: ITodo[];
  family: IFamilyMember[];
  scrollTime?: number;
  hide?: boolean;
  hideHeader?:boolean;
  completeTodo: (data: ICompleteTodo) => void;
  hideTodo: (data: IHideTodo) => void;
  seenTodo: (data: IHideTodo) => void;
  showHelper?:boolean;
}

interface IState {
  openAddTodoModal: boolean;
  iHidTodo: number[];
}


class TodoList extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      openAddTodoModal: false,
      iHidTodo: [],
    };
  }


  public render() {

    const todos: JSX.Element[] = [];

    let i: number = 0;
    while (i < this.props.todos.length) {
      const todo: ITodo = this.props.todos[i];
      if (todo.completedBy && (todo.hidden && todo.hidden.indexOf(this.props.myAccountId) >= 0)
        && this.state.iHidTodo.indexOf(todo.id) === -1) {
        i = i + 1;
        continue;
      }

      todos.push(<ToDoItem
        listRow={true}
        listActive={!this.props.hide}
        index={i}
        scrollTime={this.props.hide ? 0 : this.props.scrollTime}
        key={todo.id}
        myAccountId={this.props.myAccountId}
        todoData={todo}
        animateHide={(this.state.iHidTodo.indexOf(todo.id) > -1)}
        family={this.props.family}
        complete={(completed: boolean) => {
          this.completeTask(todo.id, completed);
        }}
        hide={() => {
          this.hideTask(todo.id);
        }}
        seen={() => {
          this.props.seenTodo({id: todo.id});
        }}
      />);
      i = i + 1;
    }

    let helper: JSX.Element | null = null;

    if (todos.length === 0 && this.props.showHelper) {
      helper = <div style={{display:'flex', flexDirection:'column', position: 'absolute', top: 'calc(50% - 100px)', 
        left: 'calc(50% - 120px)', width:'240px', alignItems:'center'}}>
        <p className={this.props.classes.helpText}>
          {tn.lang.sharedTaskHelper}</p>
        <img src={'arrow.png'} style={{ width: '60px'}} alt="Arrow" />
      </div> ;
    }

    return (
      <div className={this.props.classes.root}>
        <div className={this.props.classes.todosContainer}>
          {todos}
          <CalendarTodos family={this.props.family} myAccountId={this.props.myAccountId}
            active={!this.props.hide} emptyContent={helper} />
        </div>
        <EditTodoDialog
          open={this.state.openAddTodoModal}
          close={() => this.handleClose()}
          type={TODO_TYPE.NORMAL}
        />
      </div>
    );
  }

  private handleClose() {
    this.setState({openAddTodoModal: false});
  }

  private completeTask(id: number, completed: boolean) {
    const completeRequest: ICompleteTodo = {
      complete: completed,
      id
    };
    this.props.completeTodo(completeRequest);

  }

  private hideTask(id: number) {
    const hideRequest: IHideTodo = {
      id
    };
    this.props.hideTodo(hideRequest);

    const newIHidTodo = this.state.iHidTodo.slice();
    const prevPos = newIHidTodo.indexOf(id);
    if (prevPos === -1) {
      newIHidTodo.push(id);
      this.setState({iHidTodo: newIHidTodo});
    }
  }
}

function mapStateToProp(state: any) {

  const todos: ITodo[] = state.todo.todos;
  return {
    todos: todos.filter((todo: ITodo) => todo.type === TODO_TYPE.NORMAL),
    family: state.family.family.filter((member: IFamilyMember) => member.role === FamilyMemberType.CHILD
      || member.role === FamilyMemberType.PARENT || member.role === FamilyMemberType.VIEWER),
  };
}

const mapDispatchToProps = {
  completeTodo: TodoActions.completeTodo,
  hideTodo: TodoActions.hideTodo,
  seenTodo: TodoActions.seenTodo,
};

export default connect(mapStateToProp, mapDispatchToProps)(withStyles(styles)(TodoList));



// WEBPACK FOOTER //
// ./src/components/todo/TodoList.tsx